var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"pt-5 pb-5"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',{staticClass:"fs-4 font-weight-bold mb-3"},[_vm._v("Cadeaukaartsaldo")]),_c('b-alert',{attrs:{"variant":"info","show":""}},[_vm._v("Geen tegoed beschikbaar.")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }